// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { RestrictedUnitRule, RestrictedUnitRuleT } from '../tbs/restricted-unit-rule.js';


export class StateConfig implements flatbuffers.IUnpackableObject<StateConfigT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StateConfig {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStateConfig(bb:flatbuffers.ByteBuffer, obj?:StateConfig):StateConfig {
  return (obj || new StateConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStateConfig(bb:flatbuffers.ByteBuffer, obj?:StateConfig):StateConfig {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StateConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

fow():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

incomeMult():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
}

startIncome():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

winMapControlPercent():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

winAnnexAnyHq():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

requireCompleteKills():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

winMaxDays():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

maxUnitsPerPlayer():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

restrictedUnits(index: number, obj?:RestrictedUnitRule):RestrictedUnitRule|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new RestrictedUnitRule()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

restrictedUnitsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startStateConfig(builder:flatbuffers.Builder) {
  builder.startObject(9);
}

static addFow(builder:flatbuffers.Builder, fow:boolean) {
  builder.addFieldInt8(0, +fow, +false);
}

static addIncomeMult(builder:flatbuffers.Builder, incomeMult:number) {
  builder.addFieldInt32(1, incomeMult, 1);
}

static addStartIncome(builder:flatbuffers.Builder, startIncome:number) {
  builder.addFieldInt32(2, startIncome, 0);
}

static addWinMapControlPercent(builder:flatbuffers.Builder, winMapControlPercent:number) {
  builder.addFieldInt32(3, winMapControlPercent, -1);
}

static addWinAnnexAnyHq(builder:flatbuffers.Builder, winAnnexAnyHq:boolean) {
  builder.addFieldInt8(4, +winAnnexAnyHq, +false);
}

static addRequireCompleteKills(builder:flatbuffers.Builder, requireCompleteKills:boolean) {
  builder.addFieldInt8(5, +requireCompleteKills, +false);
}

static addWinMaxDays(builder:flatbuffers.Builder, winMaxDays:number) {
  builder.addFieldInt32(6, winMaxDays, -1);
}

static addMaxUnitsPerPlayer(builder:flatbuffers.Builder, maxUnitsPerPlayer:number) {
  builder.addFieldInt32(7, maxUnitsPerPlayer, -1);
}

static addRestrictedUnits(builder:flatbuffers.Builder, restrictedUnitsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, restrictedUnitsOffset, 0);
}

static createRestrictedUnitsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startRestrictedUnitsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endStateConfig(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStateConfig(builder:flatbuffers.Builder, fow:boolean, incomeMult:number, startIncome:number, winMapControlPercent:number, winAnnexAnyHq:boolean, requireCompleteKills:boolean, winMaxDays:number, maxUnitsPerPlayer:number, restrictedUnitsOffset:flatbuffers.Offset):flatbuffers.Offset {
  StateConfig.startStateConfig(builder);
  StateConfig.addFow(builder, fow);
  StateConfig.addIncomeMult(builder, incomeMult);
  StateConfig.addStartIncome(builder, startIncome);
  StateConfig.addWinMapControlPercent(builder, winMapControlPercent);
  StateConfig.addWinAnnexAnyHq(builder, winAnnexAnyHq);
  StateConfig.addRequireCompleteKills(builder, requireCompleteKills);
  StateConfig.addWinMaxDays(builder, winMaxDays);
  StateConfig.addMaxUnitsPerPlayer(builder, maxUnitsPerPlayer);
  StateConfig.addRestrictedUnits(builder, restrictedUnitsOffset);
  return StateConfig.endStateConfig(builder);
}

unpack(): StateConfigT {
  return new StateConfigT(
    this.fow(),
    this.incomeMult(),
    this.startIncome(),
    this.winMapControlPercent(),
    this.winAnnexAnyHq(),
    this.requireCompleteKills(),
    this.winMaxDays(),
    this.maxUnitsPerPlayer(),
    this.bb!.createObjList<RestrictedUnitRule, RestrictedUnitRuleT>(this.restrictedUnits.bind(this), this.restrictedUnitsLength())
  );
}


unpackTo(_o: StateConfigT): void {
  _o.fow = this.fow();
  _o.incomeMult = this.incomeMult();
  _o.startIncome = this.startIncome();
  _o.winMapControlPercent = this.winMapControlPercent();
  _o.winAnnexAnyHq = this.winAnnexAnyHq();
  _o.requireCompleteKills = this.requireCompleteKills();
  _o.winMaxDays = this.winMaxDays();
  _o.maxUnitsPerPlayer = this.maxUnitsPerPlayer();
  _o.restrictedUnits = this.bb!.createObjList<RestrictedUnitRule, RestrictedUnitRuleT>(this.restrictedUnits.bind(this), this.restrictedUnitsLength());
}
}

export class StateConfigT implements flatbuffers.IGeneratedObject {
constructor(
  public fow: boolean = false,
  public incomeMult: number = 1,
  public startIncome: number = 0,
  public winMapControlPercent: number = -1,
  public winAnnexAnyHq: boolean = false,
  public requireCompleteKills: boolean = false,
  public winMaxDays: number = -1,
  public maxUnitsPerPlayer: number = -1,
  public restrictedUnits: (RestrictedUnitRuleT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const restrictedUnits = StateConfig.createRestrictedUnitsVector(builder, builder.createObjectOffsetList(this.restrictedUnits));

  return StateConfig.createStateConfig(builder,
    this.fow,
    this.incomeMult,
    this.startIncome,
    this.winMapControlPercent,
    this.winAnnexAnyHq,
    this.requireCompleteKills,
    this.winMaxDays,
    this.maxUnitsPerPlayer,
    restrictedUnits
  );
}
}
